import { apiService } from '../../../../'
import { MarketingPreferencesResponse } from '../types'

const baseURL = '/portal/consumers/subscriptions/marketing'

export const marketingPreferencesService = apiService.service.injectEndpoints({
  endpoints: (build) => ({
    getMarketingPreferences: build.query<MarketingPreferencesResponse, void>({
      query: () => {
        return {
          url: baseURL,
          method: 'GET',
        }
      },
      providesTags: ['MarketingPreferences'],
    }),
    subscribeToMarketingEmails: build.mutation({
      query: () => ({
        url: `${baseURL}/subscribed`,
        method: 'PUT',
      }),
      invalidatesTags: ['MarketingPreferences'],
    }),
    unsubscribeFromMarketingEmails: build.mutation({
      query: () => ({
        url: `${baseURL}/unsubscribed`,
        method: 'PUT',
      }),
      invalidatesTags: ['MarketingPreferences'],
    }),
  }),
})
